"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TypingStatus;
(function (TypingStatus) {
    TypingStatus[TypingStatus["Typing"] = 0] = "Typing";
    TypingStatus[TypingStatus["ClearTyping"] = 1] = "ClearTyping";
})(TypingStatus || (TypingStatus = {}));
exports.default = TypingStatus;
//# sourceMappingURL=TypingStatus.js.map